module.exports = {"id":"190670","name":"Dominic Maroh","rating":"75","photo":"./data/images/photos/0/190670.png","club":{"name":"1. FC Cologne","logo":"./data/images/clubs/1.FCCologne.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DominicMaroh0.json
// module id = 1133
// module chunks = 0